import React, { FunctionComponent } from 'react';

export const NewsIcon: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <svg
      width="60px"
      height="60px"
      viewBox="0 0 60 60"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <circle id="NewsIconPath-1" cx="30" cy="30" r="30"></circle>
        <path
          d="M32.6791667,3.55271368e-14 C33.4625786,3.55271368e-14 34.1,0.637421354 34.1,1.42083333 L34.1,1.42083333 L34.1,21.3125 C34.1,22.095912 33.4625786,22.7333333 32.6791667,22.7333333 L32.6791667,22.7333333 L2.84166667,22.7333333 C1.27223785,22.7333333 0,21.4610955 0,19.8916667 L0,19.8916667 L0,3.31527778 C0,2.53056337 0.636118924,1.89444444 1.42083333,1.89444444 L1.42083333,1.89444444 L3.78888889,1.89444444 L3.78888889,1.42083333 C3.78888889,0.637421354 4.42625104,3.55271368e-14 5.20972222,3.55271368e-14 L5.20972222,3.55271368e-14 Z M3.78888889,3.78888889 L1.89444444,3.78888889 L1.89444444,19.8916667 C1.89444444,20.4139413 2.31939201,20.8388889 2.84166667,20.8388889 C3.36394132,20.8388889 3.78888889,20.4139413 3.78888889,19.8916667 L3.78888889,19.8916667 L3.78888889,3.78888889 Z M29.5559003,17.05 L8.28819444,17.05 C7.89586684,17.05 7.57777778,17.3680891 7.57777778,17.7604167 L7.57777778,17.7604167 L7.57777778,18.2340278 C7.57777778,18.6263554 7.89586684,18.9444444 8.28819444,18.9444444 L8.28819444,18.9444444 L29.5559003,18.9444444 C29.9482279,18.9444444 30.2663169,18.6263554 30.2663169,18.2340278 L30.2663169,18.2340278 L30.2663169,17.7604167 C30.2663169,17.3680891 29.9482279,17.05 29.5559003,17.05 L29.5559003,17.05 Z M29.6006944,13.2611111 L21.5493056,13.2611111 C21.156978,13.2611111 20.8388889,13.5792002 20.8388889,13.9715278 L20.8388889,13.9715278 L20.8388889,14.4451389 C20.8388889,14.8374665 21.156978,15.1555556 21.5493056,15.1555556 L21.5493056,15.1555556 L29.6006944,15.1555556 C29.993022,15.1555556 30.3111111,14.8374665 30.3111111,14.4451389 L30.3111111,14.4451389 L30.3111111,13.9715278 C30.3111111,13.5792002 29.993022,13.2611111 29.6006944,13.2611111 L29.6006944,13.2611111 Z M18.2340278,3.78888889 L8.28819444,3.78888889 C7.89586684,3.78888889 7.57777778,4.10697795 7.57777778,4.49930556 L7.57777778,14.4451389 C7.57777778,14.8374665 7.89586684,15.1555556 8.28819444,15.1555556 L18.2340278,15.1555556 C18.6263554,15.1555556 18.9444444,14.8374665 18.9444444,14.4451389 L18.9444444,4.49930556 C18.9444444,4.10697795 18.6263554,3.78888889 18.2340278,3.78888889 Z M29.6006944,9.47222222 L21.5493056,9.47222222 C21.156978,9.47222222 20.8388889,9.79031128 20.8388889,10.1826389 L20.8388889,10.1826389 L20.8388889,10.65625 C20.8388889,11.0485776 21.156978,11.3666667 21.5493056,11.3666667 L21.5493056,11.3666667 L29.6006944,11.3666667 C29.993022,11.3666667 30.3111111,11.0485776 30.3111111,10.65625 L30.3111111,10.65625 L30.3111111,10.1826389 C30.3111111,9.79031128 29.993022,9.47222222 29.6006944,9.47222222 L29.6006944,9.47222222 Z M29.6006944,5.68333333 L21.5493056,5.68333333 C21.156978,5.68333333 20.8388889,6.0014224 20.8388889,6.39375 L20.8388889,6.39375 L20.8388889,6.86736111 C20.8388889,7.25968872 21.156978,7.57777778 21.5493056,7.57777778 L21.5493056,7.57777778 L29.6006944,7.57777778 C29.993022,7.57777778 30.3111111,7.25968872 30.3111111,6.86736111 L30.3111111,6.86736111 L30.3111111,6.39375 C30.3111111,6.0014224 29.993022,5.68333333 29.6006944,5.68333333 L29.6006944,5.68333333 Z"
          id="NewsIconPath-3"
        ></path>
      </defs>
      <g
        id="NewsIcon"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Components/icons/circle-coloured-Copy-15">
          <g id="NewsIconColours/Pear-#CAD526">
            <mask id="NewsIconMask-2" fill="white">
              <use xlinkHref="#NewsIconPath-1"></use>
            </mask>
            <circle stroke="#EEEEEE" cx="30" cy="30" r="29.5"></circle>
            <g id="NewsIconGroup" mask="url(#NewsIconMask-2)" fill="#C33C8E">
              <g id="NewsIconColours/Pear-#CAD526">
                <rect
                  id="NewsIconRectangle"
                  x="0"
                  y="0"
                  width="60"
                  height="60"
                ></rect>
              </g>
            </g>
          </g>
          <g id="NewsIconGroup" transform="translate(11.400000, 11.400000)">
            <g
              id="NewsIconColours/Black-#000000"
              transform="translate(1.550000, 7.750000)"
            >
              <mask id="NewsIconMask-4" fill="white">
                <use xlinkHref="#NewsIconPath-3"></use>
              </mask>
              <use
                id="NewsIconMask"
                fill="#FFFFFF"
                fillRule="nonzero"
                xlinkHref="#NewsIconPath-3"
              ></use>
              <g id="NewsIconGroup" mask="url(#NewsIconMask-4)">
                <g
                  transform="translate(-17.050000, -23.250000)"
                  id="NewsIconColours/Black-#000000"
                >
                  <rect
                    id="NewsIconRectangle"
                    fill="#FFFFFF"
                    x="0"
                    y="0"
                    width="68.2"
                    height="68.2"
                  ></rect>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default NewsIcon;
